export class TextoErrores {
	public static ERROR_VISTA_NO_EXISTE = 'Vista no configurada';
	public static ERROR_BASE64 = 'Illegal base64url string!';
	public static ERROR_ESTRUCTURA_JWT = 'JWT must have 3 parts';
	public static ERROR_DECODIFICA_JWT = 'Cannot decode the token';

}


